import { SearchData, SearchParams } from "@radarly/models/search";

export interface SearchRepository {
  searchFragmentData<T extends SearchData>(
    project: number,
    query: SearchParams,
    mutualized?: boolean
  ): Promise<T>;
}

export const SearchRepositoryUID = Symbol("Radarly/SearchRepository");
